export default __webpack_public_path__ + "static/media/auman_11.5318450a.png";